/**
 * Функция для пересчета азимута в градусы. Например азимут 90 - 0 градусов.
 */
export const azimutToDegree = (azimuth: number | string): number => {
  const angle = typeof azimuth === 'string' ? parseFloat(azimuth) : azimuth;
  if (angle <= 90) return 90 - angle;
  return 90 + (360 - angle);
};
